/*global $, INFO_PAGE, escape, suitsmenCountdown, ITEM_INFO, refreshSuitInfo*/

/*eslint camelcase: [2, {properties: "never"}]*/
function refreshSuitInfo(optionId, clear, selectionHighlightsActive) {
  "use strict";
  if (clear) {
    INFO_PAGE.refreshSettings.size_title = "size";
    INFO_PAGE.refreshSettings.secondary_size = "secondary_size";
    INFO_PAGE.refreshSettings.colour = "colour";
  } else if (optionId !== "bespoke_fit_classic" && optionId !== "bespoke_fit_slim") {

    /* SIZE */
    if (INFO_PAGE.product_options[ optionId ].type === "jacket_size") {
      INFO_PAGE.refreshSettings.jacket_size_id = INFO_PAGE.product_options[ optionId ].id;
      INFO_PAGE.refreshSettings.jacket_size = INFO_PAGE.product_options[ optionId ].url_title;
      if (INFO_PAGE.refreshSettings.trouser_size.length === 0) {
        INFO_PAGE.refreshSettings.size_title = INFO_PAGE.product_options[ optionId ].url_title;
      } else {
        INFO_PAGE.refreshSettings.size_title = INFO_PAGE.product_options[ optionId ].url_title + "~" + INFO_PAGE.refreshSettings.trouser_size;
      }
    }

    if (INFO_PAGE.product_options[ optionId ].type === "trouser_size") {
      INFO_PAGE.refreshSettings.trouser_size_id = INFO_PAGE.product_options[ optionId ].id;
      INFO_PAGE.refreshSettings.trouser_size = INFO_PAGE.product_options[ optionId ].url_title;
      if (INFO_PAGE.refreshSettings.jacket_size.length === 0) {
        INFO_PAGE.refreshSettings.size_title = "size~" + INFO_PAGE.product_options[ optionId ].url_title;
      } else {
        INFO_PAGE.refreshSettings.size_title = INFO_PAGE.refreshSettings.jacket_size + "~" + INFO_PAGE.refreshSettings.trouser_size;
      }
    }

    /* SECONDARY SIZE */
    if (INFO_PAGE.product_options[ optionId ].type === "jacket_secondary_size") {
      INFO_PAGE.refreshSettings.jacket_secondary_size_id = INFO_PAGE.product_options[ optionId ].id;
      INFO_PAGE.refreshSettings.jacket_secondary_size = INFO_PAGE.product_options[ optionId ].url_title;
      if (INFO_PAGE.refreshSettings.trouser_secondary_size.length === 0) {
        INFO_PAGE.refreshSettings.secondary_size = INFO_PAGE.product_options[ optionId ].url_title;
      } else {
        INFO_PAGE.refreshSettings.secondary_size = INFO_PAGE.product_options[ optionId ].url_title + "~" + INFO_PAGE.refreshSettings.trouser_secondary_size;
      }
    }

    if (INFO_PAGE.product_options[ optionId ].type === "trouser_secondary_size") {
      INFO_PAGE.refreshSettings.trouser_secondary_size_id = INFO_PAGE.product_options[ optionId ].id;
      INFO_PAGE.refreshSettings.trouser_secondary_size = INFO_PAGE.product_options[ optionId ].url_title;
      if (INFO_PAGE.refreshSettings.jacket_secondary_size.length === 0) {
        INFO_PAGE.refreshSettings.secondary_size = "secondary_size~" + INFO_PAGE.product_options[ optionId ].url_title;
      } else {
        INFO_PAGE.refreshSettings.secondary_size = INFO_PAGE.refreshSettings.jacket_secondary_size + "~" + INFO_PAGE.refreshSettings.trouser_secondary_size;
      }
    }

    /* COLOUR */
    if (INFO_PAGE.product_options[ optionId ].type === "jacket_colour") {
      INFO_PAGE.refreshSettings.jacket_colour = INFO_PAGE.product_options[ optionId ].title;
      if (INFO_PAGE.refreshSettings.trouser_colour.length === 0) {
        INFO_PAGE.refreshSettings.colour = INFO_PAGE.product_options[ optionId ].title;
      } else {
        INFO_PAGE.refreshSettings.colour = INFO_PAGE.product_options[ optionId ].title + "~" + INFO_PAGE.refreshSettings.trouser_colour;
      }
    }

    if (INFO_PAGE.product_options[ optionId ].type === "trouser_colour") {
      INFO_PAGE.refreshSettings.trouser_colour = INFO_PAGE.product_options[ optionId ].title;
      if (INFO_PAGE.refreshSettings.jacket_colour.length === 0) {
        INFO_PAGE.refreshSettings.colour = "colour~" + INFO_PAGE.product_options[ optionId ].title;
      } else {
        INFO_PAGE.refreshSettings.colour = INFO_PAGE.refreshSettings.jacket_colour + "~" + INFO_PAGE.refreshSettings.trouser_colour;
      }
    }

  }

  var data = "";

  data += "category_id";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.category_id);
  data += "&";

  data += "category";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.category);
  data += "&";

  data += "style_id";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.style_id);
  data += "&";

  data += "style";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.style_title);
  data += "&";

  data += "brand_id";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.brand_id);
  data += "&";

  data += "brand";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.brand);
  data += "&";

  data += "size";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.size_title);
  data += "&";

  data += "secondary_size";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.secondary_size);
  data += "&";

  data += "colour";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.colour);
  data += "&";

  data += "fabric_id";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.fabric_id);
  data += "&";

  data += "fabric";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.fabric);
  data += "&";

  data += "occasion_id";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.occasion_id);
  data += "&";

  data += "occasion";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.occasion);
  data += "&";

  data += "sale";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.sale);
  data += "&";

  data += "suit_type_id";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.suit_type_id);
  data += "&";

  data += "suit_type";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.suit_type);
  data += "&";

  data += "trouser_type_id";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.trouser_type_id);
  data += "&";

  data += "trouser_type";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.trouser_type);
  data += "&";

  data += "suit_id";
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.suit_id);
  data += "&";

  var rand = Math.random(9999);
  var pars = data + "rand=" + rand;
  var countdownRefresher;

  $.get("/lib/ajax_suit_info_json.php", pars, function (newData) {
    var infoContentHtml = newData.info;
    var sizeChartHtml = newData.size_charts;
    var priceBoxHtml = newData.price;

    var selectionsPanel = $(".selections-wrapper");
    selectionsPanel.html(infoContentHtml);

    var sizeChartDiv = $(".size-chart-section");
    sizeChartDiv.html(sizeChartHtml);

    $(".price_box-xs").html(priceBoxHtml);
    $(".price_box-sm").html(priceBoxHtml);
    $(".price_box-btn").html(priceBoxHtml);


    clearInterval(countdownRefresher);
    suitsmenCountdown.getBanner();
    countdownRefresher = window.setInterval(function () {
      suitsmenCountdown.getBanner();
    }, 60000);


    if (selectionHighlightsActive) {
      ITEM_INFO.messageOn();
    }

    //Measurement Sizechart and diagrams
    $("#jacket_measurement_sizechart .mv").removeClass("active_size");
    $("#jacket_measurement_sizechart .mv").removeClass("active_secondary_size");

    $("#jacket_measurement_sizechart .mv").each(function () {
      if ($(this).hasClass("s_" + INFO_PAGE.refreshSettings.jacket_size_id)) {
        $(this).addClass("active_size");
      }
      if ($(this).hasClass("ss_" + INFO_PAGE.refreshSettings.jacket_secondary_size_id) && String(INFO_PAGE.refreshSettings.jacket_secondary_size_id) !== "0") {
        $(this).addClass("active_secondary_size");
      }
    });

    //if a main size is set update any diagrams main size values
    if (String(INFO_PAGE.refreshSettings.jacket_size_id) !== "0") {
      var mainInch = $("#jacket_measurement_sizechart  .ms_s_" + INFO_PAGE.refreshSettings.jacket_size_id + " > .inch").html();
      var mainCm = $("#jacket_measurement_sizechart  .ms_s_" + INFO_PAGE.refreshSettings.jacket_size_id + " > .cm").html() + "cm";

      $("#jacket_measurement_sizechart .diagram_measurement.main_size > .inch").html(mainInch);
      $("#jacket_measurement_sizechart .diagram_measurement.main_size > .cm").html(mainCm);
    }

    //if a secondary size is set update any diagrams secondary size values
    if (String(INFO_PAGE.refreshSettings.jacket_secondary_size_id) !== "0") {
      var ssInch = $("#jacket_measurement_sizechart  .secondary_size.ss_" + INFO_PAGE.refreshSettings.jacket_secondary_size_id + " > .inch").html();
      var ssCm = $("#jacket_measurement_sizechart  .secondary_size.ss_" + INFO_PAGE.refreshSettings.jacket_secondary_size_id + " > .cm").html() + "cm";

      $("#jacket_measurement_sizechart .diagram_measurement.secondary_size > .inch").html(ssInch);
      $("#jacket_measurement_sizechart .diagram_measurement.secondary_size > .cm").html(ssCm);
    }

    //alert($(".secondary_size").length);

    var measurementTypeId = 0;
    var mtInch = "";
    var mtCm = "";
    //check if there are any secondary sizes for this product
    if ($("#jacket_measurement_sizechart  .secondary_size").length) {
      //has secondary sizes
      $("#jacket_measurement_sizechart  .active_size.active_secondary_size").each(function () {

        var classList = $(this).attr("class").split(/\s+/);
        for (var i = 0; i < classList.length; i++) {
          if (classList[ i ].length > 0) {
            if (classList[ i ].match(/mt_id_(\d*)/)) {
              measurementTypeId = RegExp.$1;
              mtInch = $(this).find(".inch").html();
              mtCm = $(this).find(".cm").html() + "cm";
              $("#jacket_measurement_sizechart .diagram_measurement.mt_id_" + measurementTypeId + " > .inch").html(mtInch);
              $("#jacket_measurement_sizechart .diagram_measurement.mt_id_" + measurementTypeId + " > .cm").html(mtCm);
            }
          }
        }


      });
    } else {
      //no secondary sizes
      $("#jacket_measurement_sizechart .active_size").each(function () {

        var classList = $(this).attr("class").split(/\s+/);
        for (var i = 0; i < classList.length; i++) {
          if (classList[ i ].length > 0) {
            if (classList[ i ].match(/mt_id_(\d*)/)) {
              measurementTypeId = RegExp.$1;
              mtInch = $(this).find(".inch").html();
              mtCm = $(this).find(".cm").html() + "cm";
              $("#jacket_measurement_sizechart .diagram_measurement.mt_id_" + measurementTypeId + " > .inch").html(mtInch);
              $("#jacket_measurement_sizechart .diagram_measurement.mt_id_" + measurementTypeId + " > .cm").html(mtCm);
            }
          }
        }


      });
    }

    //trouser measurement sizechart
    $("#trouser_measurement_sizechart .mv").removeClass("active_size");
    $("#trouser_measurement_sizechart .mv").removeClass("active_secondary_size");

    $("#trouser_measurement_sizechart .mv").each(function () {
      if ($(this).hasClass("s_" + INFO_PAGE.refreshSettings.trouser_size_id)) {
        $(this).addClass("active_size");
      }
      if ($(this).hasClass("ss_" + INFO_PAGE.refreshSettings.trouser_secondary_size_id) && String(INFO_PAGE.refreshSettings.trouser_secondary_size_id) !== "0") {
        $(this).addClass("active_secondary_size");
      }
    });

    //if a main size is set update any diagrams main size values
    if (String(INFO_PAGE.refreshSettings.trouser_size_id) !== "0") {
      var trouserMainInch = $("#trouser_measurement_sizechart  .ms_s_" + INFO_PAGE.refreshSettings.trouser_size_id + " > .inch").html();
      var trouserMainCm = $("#trouser_measurement_sizechart  .ms_s_" + INFO_PAGE.refreshSettings.trouser_size_id + " > .cm").html() + "cm";

      $("#trouser_measurement_sizechart  .diagram_measurement.main_size > .inch").html(trouserMainInch);
      $("#trouser_measurement_sizechart  .diagram_measurement.main_size > .cm").html(trouserMainCm);
    }

    //if a secondary size is set update any diagrams secondary size values
    if (String(INFO_PAGE.refreshSettings.trouser_secondary_size_id) !== "0") {
      var trouserSsInch = $("#trouser_measurement_sizechart  .secondary_size.ss_" + INFO_PAGE.refreshSettings.trouser_secondary_size_id + " > .inch").html();
      var trouserSsCm = $("#trouser_measurement_sizechart  .secondary_size.ss_" + INFO_PAGE.refreshSettings.trouser_secondary_size_id + " > .cm").html() + "cm";

      $("#trouser_measurement_sizechart  .diagram_measurement.secondary_size > .inch").html(trouserSsInch);
      $("#trouser_measurement_sizechart  .diagram_measurement.secondary_size > .cm").html(trouserSsCm);
    }

    //alert($(".secondary_size").length);

    var trouserMeasurementTypeId = 0;
    var trouserMtInch = "";
    var trouserMtCm = "";
    //check if there are any secondary sizes for this product
    if ($("#trouser_measurement_sizechart  .secondary_size").length) {
      //has secondary sizes
      $("#trouser_measurement_sizechart  .active_size.active_secondary_size").each(function () {

        var classList = $(this).attr("class").split(/\s+/);
        for (var i = 0; i < classList.length; i++) {
          if (classList[ i ].length > 0) {
            if (classList[ i ].match(/mt_id_(\d*)/)) {
              trouserMeasurementTypeId = RegExp.$1;
              trouserMtInch = $(this).find(".inch").html();
              trouserMtCm = $(this).find(".cm").html() + "cm";
              $("#trouser_measurement_sizechart .diagram_measurement.mt_id_" + trouserMeasurementTypeId + " > .inch").html(trouserMtInch);
              $("#trouser_measurement_sizechart .diagram_measurement.mt_id_" + trouserMeasurementTypeId + " > .cm").html(trouserMtCm);
            }
          }
        }


      });
    } else {
      //no secondary sizes
      $("#trouser_measurement_sizechart .active_size").each(function () {

        var classList = $(this).attr("class").split(/\s+/);
        for (var i = 0; i < classList.length; i++) {
          if (classList[ i ].length > 0) {
            if (classList[ i ].match(/mt_id_(\d*)/)) {
              trouserMeasurementTypeId = RegExp.$1;
              trouserMtInch = $(this).find(".inch").html();
              trouserMtCm = $(this).find(".cm").html() + "cm";
              $("#trouser_measurement_sizechart .diagram_measurement.mt_id_" + trouserMeasurementTypeId + " > .inch").html(trouserMtInch);
              $("#trouser_measurement_sizechart .diagram_measurement.mt_id_" + trouserMeasurementTypeId + " > .cm").html(trouserMtCm);
            }
          }
        }
      });
    }

    //restore add to bag tracking
    // $("#product_info_form #buy").unbind('click');
    $("#product_info_form #buy").on('click', function (e) {
      e.stopPropagation();
      var qtyInput = $('#jacket_qty');

      try {
        window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "add_to_cart",
            currency: "GBP",
            value: newData.plain_price,
            ecommerce: {
                items: [ {
                item_id: INFO_PAGE.refreshSettings.suit_id,
                item_name: INFO_PAGE.suit_title,
                item_category: INFO_PAGE.refreshSettings.category,
                item_variant: newData.plain_size + ' ' + newData.plain_secondary_size + ' ' + newData.colour,
                item_brand: INFO_PAGE.suit_brand,
                currency: "GBP",
                price: newData.plain_price,
                quantity: qtyInput.val(),
                index: 0,
                dimension1: newData.plain_size,
                dimension2: newData.plain_secondary_size,
                dimension3: newData.colour,
              } ]
            }
        });
      } catch (error) {
        // console.log(error);
      }
    });


  }, "json");
}
